export const getOriginDomain = (): string => {
  const parts = window.location.href.split('.');

  return parts.length > 2 ? parts.slice(1).join('.') : window.location.href;
};

export const isShobiddak = (): boolean =>
  getOriginDomain() === process.env.REACT_APP_SHOBIDAK_DOMAIN;
